import { ToastProgrammatic as Toast } from 'buefy';

export const ToastMixin = {
    methods: {
        $showToast(lvl, message) {
            Toast.open({
                duration: 4000,
                message: message,
                position: 'is-top',
                type: 'is-' + lvl
            });
        },
        $toastSuccess(message) {
            this.$showToast('success', message);
        },
        $toastError(message) {
            this.$showToast('danger', message);
        },
        $toastGenericError() {
            this.$toastError(this.$t('error_something_went_wrong'));
        }
    }
};
